import React, { useState, useEffect } from "react"
import { Row, Col } from "reactstrap"
import { getCurrentUser } from "../../../helpers/Utils.js"
import axios from "axios"
import Paginations from "../../Pagination/index.jsx"
import Loader from "../../Loader/loader.js"
import CschemeList from "./CschemeList.js"
import CschemeModal from "./CschemeModal.js"

const CschemeTable = props => {
  const [modal_standard, setmodal_standard] = useState(false)
  const [schemes, setSchemes] = useState([])
  const [error, setError] = useState("")
  const [loader, setLoader] = useState(<Loader />)
  const [allPages, setAllPages] = useState([])
  const [counter, setCounter] = useState("")

  const getAllSchemes = () => {
    setLoader(<Loader />)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/customer-scheme?customer_id=${props.leadId}&per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setError(res.data.message)
          setCounter(res.data.data.from)
          setSchemes(res.data.data.data)
          setAllPages(res.data.data)
        } else {
          setLoader("")
          setError(res.data.message)
        }
      })
  }

  const paginate = e => {
    setSchemes([])
    setAllPages([])
    setCounter("")
    setLoader(<Loader />)
    axios
      .get(`${e}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${
            getCurrentUser().token == null ? "" : getCurrentUser().token
          }`,
        },
      })
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setCounter(res.data.data.from)
          setAllPages(res.data.data)
          setSchemes(res.data.data.data)
        } else {
          setError(res.data.message)
          setLoader("")
        }
      })
  }

  useEffect(() => {
    getAllSchemes()
  }, [])

  return (
    <>
      <CschemeModal
        modal_standard={modal_standard}
        id={props.leadId}
        setmodal_standard={setmodal_standard}
        getAllSchemes={getAllSchemes}
      />
      <div className="page-title-box">
        <Row className="align-items-center">
          <Col md={6}>
            <h6 className="page-title">Recent Schemes</h6>
          </Col>
          <Col md={6}>
            <h6 className="page-title float-end">
              <button
                className="btn btn-success submit__button"
                type="button"
                onClick={() => {
                  setmodal_standard(true)
                }}
              >
                Add New
              </button>
            </h6>
          </Col>
        </Row>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="lead_table table-responsive">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <th>#</th>
                  <th>Scheme ID</th>
                  <th>Message</th>
                  <th>Start date</th>
                  <th>End date</th>
                  <th>Qualified</th>
                  <th>Action</th>
                </tr>
                {schemes &&
                  schemes.map((item, obj) => (
                    <CschemeList
                      key={obj}
                      data={item}
                      i={obj}
                      counter={counter}
                    />
                  ))}
              </tbody>
            </table>
            {error ? (
              <span className="text-danger mt-3 d-table m-auto" role="alert">
                {error}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {loader}
      {allPages !== [] ? (
        <Paginations
          data={allPages}
          paginate={paginate}
          perPage={getAllSchemes}
        />
      ) : (
        ""
      )}
    </>
  )
}
export default CschemeTable
